import styled, { createGlobalStyle } from 'styled-components';

import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const JumpToNavigation = styled.nav`
    padding: ${getPurpurSpacing('200')};
    border-radius: ${getPurpurBorder('radiusMd')};
    border: ${getPurpurBorder('widthXs')} dashed ${getPurpurColor('borderMedium')};
    width: 100%;

    > ul {
        margin: ${getPurpurSpacing('150')} 0 0 0;
        padding: 0;
        list-style: none;
    }
`;

export const GlobalSmoothScrollStyle = createGlobalStyle`
    html {
        scroll-behavior: smooth;
    }
`;
